// Shared chrome for the public auth screens (login, forgot password, reset
// password). They sit back-to-back in one flow, so drifting styles between them
// is immediately visible.

export const authKeyframes = `
  @keyframes floatOrb1 {
    0%, 100% { transform: translate(0, 0) scale(1); }
    50% { transform: translate(40px, -30px) scale(1.08); }
  }
  @keyframes floatOrb2 {
    0%, 100% { transform: translate(0, 0) scale(1); }
    50% { transform: translate(-50px, 40px) scale(1.12); }
  }
  @keyframes floatOrb3 {
    0%, 100% { transform: translate(0, 0) scale(1); }
    50% { transform: translate(30px, 30px) scale(0.94); }
  }
  @keyframes cardIn {
    from { opacity: 0; transform: translateY(18px) scale(0.98); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }
  @keyframes logoGlow {
    0%, 100% { filter: drop-shadow(0 0 10px rgba(255,255,255,0.25)); }
    50% { filter: drop-shadow(0 0 22px rgba(255,255,255,0.5)); }
  }
`;

export const authInputSx = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: "rgba(255,255,255,0.06)",
    borderRadius: "12px",
    color: "#fff",
    fontSize: "14px",
    fontFamily: "'Rubik', sans-serif",
    transition: "all 0.15s ease",
    "& fieldset": { borderColor: "rgba(255,255,255,0.16)" },
    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.3)" },
    "&.Mui-focused fieldset": { borderColor: "#c01e2e", borderWidth: "1.5px" },
    "&.Mui-focused": { boxShadow: "0 0 0 3px rgba(192,30,46,0.25)" },
  },
  "& .MuiInputBase-input": { color: "#fff" },
  "& .MuiInputLabel-root": {
    color: "rgba(255,255,255,0.5)",
    fontSize: "14px",
    fontFamily: "'Rubik', sans-serif",
  },
  "& .MuiInputLabel-root.Mui-focused": { color: "#ff6b7a" },
};

export const authPageSx = {
  minHeight: "100vh",
  background:
    "radial-gradient(1200px 700px at 15% 0%, rgba(192,30,46,0.35), transparent 60%), radial-gradient(1000px 600px at 90% 100%, rgba(30,58,95,0.5), transparent 55%), linear-gradient(160deg, #0d0d0f 0%, #1a1a1d 55%, #14141f 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "'Rubik', sans-serif",
  position: "relative",
  overflow: "hidden",
  p: 2,
};

export const authCardSx = {
  width: "100%",
  maxWidth: 400,
  mx: 2,
  position: "relative",
  backgroundColor: "rgba(255,255,255,0.05)",
  backdropFilter: "blur(20px)",
  border: "1px solid rgba(255,255,255,0.12)",
  borderRadius: "22px",
  boxShadow: "0 30px 70px -20px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.08)",
  padding: "44px 36px 36px",
  animation: "cardIn 0.5s cubic-bezier(0.16, 1, 0.3, 1)",
};

export const authButtonStyle = (busy) => ({
  marginTop: "4px",
  width: "100%",
  padding: "13px",
  background: busy
    ? "rgba(192,30,46,0.5)"
    : "linear-gradient(135deg, #c01e2e 0%, #a81828 100%)",
  color: "#fff",
  border: "none",
  borderRadius: "999px",
  fontSize: "14px",
  fontWeight: 700,
  cursor: busy ? "not-allowed" : "pointer",
  transition:
    "transform 0.18s cubic-bezier(0.4,0,0.2,1), box-shadow 0.18s cubic-bezier(0.4,0,0.2,1)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  fontFamily: "'Rubik', sans-serif",
  boxShadow: "0 6px 20px rgba(192,30,46,0.4), inset 0 1px 0 rgba(255,255,255,0.2)",
});
